<template>
	<div class='mMeduce'>
		<div class="pl1x">
			<div class="tabBar style-tabBar cb active-c-main_E tra-fast_E">
				<button v-for="(item,index) in btnGroup"
								:key="index"
								class="cSub afterButton"
								:class="{active:index==currentIndex}"
								@click="changeBtn(index)">{{item.title}}</button>
			</div>
		</div>
		<div class="tableScope bgContent" fillHeight="lastHeight" scroll>
			<div v-show="btnGroup[currentIndex].type=='content'" ref="contentBox"></div>
			<div v-if="!stage.setting.loc.shieldBlackList.networking" v-show="btnGroup[currentIndex].type=='network'" ref="networkBox"></div>
			<!-- <RelationshipList v-show="btnGroup[currentIndex].type=='content'" :mode="'content'" ref="content"></RelationshipList> -->
			<!-- <RelationshipList v-show="btnGroup[currentIndex].type=='network'" :mode="'network'" ref="network"></RelationshipList> -->
			<!-- 
			<div class="table table-5x tra-fast posR"
					 fillHeight="lastHeight,-.myListHeight01">
				<Loading ref="loading"></Loading>
				<div id="linkInfoList" class="cb" v-show="list.length > 0">
					<div class="scrollHide tra-fast fL"
							 :style="{'width':stage.setting.system.autoColumnWidth[0]*floatColumn.length*2+stage.setting.system.autoColumnWidth[1]}"
							 scrollFloatX="false"
							 fillHeight="lastHeight,-.myListHeight01">
						<div class="tableSys head noSelect b cField bdLight-bottom tra-fast_E" scrollFloatY="false">
							<div v-if="btnGroup[currentIndex].type=='child'" class="pl2x-imp" :title="getLanguageStr('plant302','子设备/SN号')">{{getLanguageStr('plant302','子设备/SN号')}}</div>
							<div v-if="btnGroup[currentIndex].type=='parent'" class="pl2x-imp" :title="getLanguageStr('plant315','父设备/SN号')">{{getLanguageStr('plant315','父设备/SN号')}}</div>
						</div>
						<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-.myListHeight01" scroll="{'group':'a'}">
							<table>
								<thead class="head-token">
									<tr>
										<th></th>
									</tr>
								</thead>
								<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
									<tr v-for="(device,index) in list"
											:key="index"
											@click.stop="view(device)">
										<td class="curP pl2x-imp"
												:title="device.deviceSn||''">{{device.deviceSn}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div scroll="{'axis':'x'}">
						<div class="tableSys head noSelect b cField bdLight-bottom"
								 :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}"
								 scrollFloatY="false">
							<div :title="$t('word75',['类型'])">{{$t('word75',['类型'])}}</div>
							<div class="taC" :title="$t('word166',['状态'])">{{$t('word166',['状态'])}}</div>
							<div class="taC" :title="$t('word1460',['通讯状态'])">{{$t('word1460',['通讯状态'])}}</div>这行没用到
							<div :class="{cMain:orderProperty=='update_time'}"
									 class="sequence"
									 :title="getLanguageStr('word1715','数据更新时间')"
									 @click="order('update_time')">
								<span>{{getLanguageStr('word1715','数据更新时间')}}</span>
								<span v-show="btnGroup[currentIndex].type=='child'"
											:sequence="orderProperty=='update_time'? orderDirection:''"></span>
							</div>
						</div>
						<div class="fixedScrollBar scrollY tra-fast"
								 fillHeight="lastHeight,-.myListHeight01"
								 scroll="{'group':'a'}">
							<table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
								<thead class="head-token">
									<tr>
										<th></th>
										<th></th>
										<th></th>
									</tr>
								</thead>
								<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
									<tr v-for="(device,index) in list"
											:key="index">
										<td>{{device.deviceType?getTypeText(device.deviceType,'deviceType'):'--'}}</td>
										<td class="taC">
											<span v-if="device.deviceState==null">--</span>
											<StatusIco v-else
																 :id="device.deviceState"
																 :type="'device'"></StatusIco>
										</td>
										<td :title="device.updateTime?timeFormat(device.updateTime,'utc','%Y/%m/%d %H:%M:%S'):'--'">
											<div>{{device.updateTime?timeFormat(device.updateTime,'utc','%H:%M:%S'):'--'}}</div>
											<div class="cSub">{{device.updateTime?timeFormat(device.updateTime,'utc','%Y/%m/%d'):'--'}}</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<no-result v-show="list.length == 0"></no-result>
			</div>
			<div v-show="btnGroup[currentIndex].type=='child'"
					 class="tableBatch bgContent cSub tra-fast myListHeight01"
					 :class="{disable:!list.length}">
				<Pagination class="ml2x" :pagination="pagination" :getList="_getList"></Pagination>
			</div>
			 -->
		</div>
		<div ref="view"></div>
	</div>
</template>

<script>
import { getLanguageStr } from '@/util/language'
import * as lib from '@/util/lib.js'
import StatusIco from '@/components/common/ui/StatusIco.vue'
import Pagination from '@/components/common/ui/Pagination.vue'
import NoResult from '@/components/common/ui/NoResult'
import Loading from '@/components/common/ui/Loading'
import RelationshipList from '@/components/common/RelationshipList.vue';

import * as deviceApi from '@/api/device/detail'
export default {
	name: 'linkInfo',
	components: { StatusIco, Pagination, NoResult, Loading},
	props: {
		type: {// 1运维，2设备
			type: Number,
			default: 2
		},
		siteId: {
			type: [String, Number],
			default: null
		},
		deviceId: {
			type: [String, Number],
			default: null
		},
		deviceSn:{
			type:String,
			default:""
		},
		// deviceType:{
		//   type:String,
		//   default:""
		// },
		timezone: {
			type: String,
			default: 'UTC'
		}
	},
	data () {
		return {
			currentIndex: 0,
			// btnGroup: [{
			//   title: getLanguageStr('word1530', '子设备'),
			//   type: 'child'
			// }, {
			//   title: getLanguageStr('word1531', '父设备'),
			//   type: 'parent'
			// }],
			btnGroup:[],
			pagination: {}, // 分页数据
			list: [],
			stage,
			floatColumn: ['a'],
			column: ['1', '2', '3'],
			orderProperty: 'update_time',
			orderDirection: 'DESC',
			tree:{//存放关系树组件
				content:null,
				network:null
			}
		}
	},
	methods: {
		timeFormat: lib.timeFormat,
		getLanguageStr,
		getTypeText: lib.getTypeText,
		changeBtn (index=this.currentIndex) {
			this.currentIndex = index
			// this._getList()
			switch(this.btnGroup[this.currentIndex].type){
				case "content":
					this.tree.content.show(this.deviceId);
					break;
				case "network":
					this.tree.network.show(this.deviceSn,this.deviceId);
					break;
			}
		},
		show(){
			// this._getList()
			lib.fillHeight();
			this.$nextTick(()=>{
				this.changeBtn();
			});
		},
		order (name) {
			this.orderProperty = name
			if (this.orderDirection === 'DESC') {
				this.orderDirection = 'ASC'
			} else {
				this.orderDirection = 'DESC'
			}
			this._getList()
		},
		view (data) {
			this.$bus.$emit('openViewdetail', data)
			// this.$dynamic(this.$refs.view, DeviceDetail, {bg: true, type: this.type}, {
			// }, {}).then(({instance, childInstance}) => {
			//   let dec = 1
			//   if (data.deviceType === 'COLLECTOR') {
			//     dec = 1
			//   } else {
			//     dec = 2
			//   }
			//   alert(1)
			//   childInstance.show(data, '', instance, dec, false)
			// })
		},
		// _getList () {
		//   this.$refs.loading.show()
		//   if (this.btnGroup[this.currentIndex].type == 'parent') {
		//     deviceApi.LinkParentSysListGet(-1, this.deviceId).then(res => {
		//       this.$refs.loading.hide()
		//       this.list = []
		//       if (res) {
		//         if (res.updateTime != 0) {
		//           res.updateTime += mz.tz(this.timezone)._offset * 60
		//         }

		//         this.list.push(res)
		//       }
		//     }, error => {
		//       this.$refs.loading.hide()
		//       !_.isEmpty(error) && this.$notify(error)
		//     })
		//   } else {
		//     let queryParam = {
		//       'order.direction': this.orderDirection,
		//       'order.property': this.orderProperty,
		//       page: this.pagination.request.page,
		//       size: this.pagination.request.size
		//     }
		//     deviceApi.LinkChildSysListGet(-1, this.deviceId, queryParam).then(res => {
		//       this.$refs.loading.hide()
		//       if (res && res.data) {
		//         res.data = res.data.map(item => {
		//           if (res.updateTime != 0) {
		//             item.updateTime += mz.tz(this.timezone)._offset * 60
		//           }

		//           return item
		//         })
		//       }
		//       this.list = res.data
		//       let { total } = res
		//       this.pagination = { ...this.pagination, total }
		//       this.$nextTick(function () {
		//         lib.fillHeight()
		//         lib.setScroll($('#linkInfoList [scroll]'))
		//         this.$refs.loading.hide()
		//       })
		//     }, error => {
		//       this.$refs.loading.hide()
		//       !_.isEmpty(error) && this.$notify(error)
		//     })
		//   }
		// }
	},
	created(){
		this.btnGroup.push({
				title: getLanguageStr('Networking6', '通讯关系'),
				type: 'content'
			});
		if(!stage.setting.loc.shieldBlackList.networking){
			this.btnGroup.push({
				title: getLanguageStr('Networking13', '组网关系'),
				type: 'network'
			});
		}
	},
	mounted () {
		this.$dynamic(this.$refs.contentBox,RelationshipList,{mode:"content"},{},{}).then(({instance,childInstance})=>{
			this.tree.content=childInstance;
		});
		this.$dynamic(this.$refs.networkBox,RelationshipList,{mode:"network"},{},{}).then(({instance,childInstance})=>{
			this.tree.network=childInstance;
		});
		this.$nextTick(()=>{
			lib.setScroll($(this.$el).find('[scroll]'));
		});
	}
}
</script>

<style scoped>
.tabBar > *:not(.tabBar-ex) {
	bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/device/device/part/LinkInfo.vue